import { InjectionToken } from "@angular/core";
import { IDeveloperBillingRestClient } from "./i-developer-billing-rest.client";

export const developerBillingRestClientInjectionToken: InjectionToken<IDeveloperBillingRestClient> = new InjectionToken<IDeveloperBillingRestClient>("digital-signage.developer-dashboard.dashboard-web.DeveloperBillingRestClient");
